var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTennis = function SvgTennis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 27 27",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.284 2.293C.682 3.895-.12 6.163.014 8.631c.067.867.267 1.735.534 2.535.6-.734 1.402-1.2 2.336-1.467a7.122 7.122 0 0 1-.2-1.668c0-1.468.467-2.802 1.535-3.87 2.27-2.268 6.34-1.934 9.01.734 2.67 2.669 3.003 6.738.734 9.007-1.468 1.467-3.737 1.867-5.873 1.2-.267.934-.801 1.735-1.535 2.268.067 0 .133.067.133.067 1.469.734 3.404 1.134 5.473 1.535 2.203.467 4.672.934 6.407 1.868.134.4.267.8.6 1.134l4.005 4.003c.801.8 2.07.8 2.803 0 .4-.4.6-.934.6-1.401 0-.534-.2-1.001-.6-1.401l-4.004-4.003c-.334-.334-.734-.467-1.135-.534-.867-1.668-1.401-4.203-1.869-6.471-.467-2.268-.934-4.403-1.735-5.87a10.555 10.555 0 0 0-2.202-3.203c-3.67-3.803-9.41-4.136-12.747-.8Zm15.35 15.211c-.935-.334-2.002-.6-3.004-.8.4-.267.801-.601 1.202-.935.4-.4.734-.8 1-1.2.201 1 .468 2.001.802 2.935Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.555 13.968a2.669 2.669 0 1 0-5.338.001 2.669 2.669 0 0 0 5.338 0Z"
  })));
};

export default SvgTennis;